import { createSlice } from "@reduxjs/toolkit";
import { fetchDashboardData, DashboardData } from "./thunk";

interface DashboardState {
  data: DashboardData | null;
  loading: boolean;
  error: string | null;
  filters: {
    created_at_from?: string;
    created_at_to?: string;
    createdBy?: string;
  };
}

const initialState: DashboardState = {
  data: null,
  loading: false,
  error: null,
  filters: {}
};

const DashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearDashboardData: (state) => {
      state.data = null;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboardData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchDashboardData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  }
});

export const { setFilters, clearError, clearDashboardData } = DashboardSlice.actions;
export default DashboardSlice.reducer;
